export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/card-button-circle.7b7170e1-1aa111.svg";